"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";

import { CareersApplicationScrollLink } from "@/components/careers/CareersApplicationScrollLink";

export function CareersHeroSection() {
  const scope = useRef<HTMLElement | null>(null);
  const mainRef = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
      const main = mainRef.current;
      if (!main) return;

      gsap.set(main, { autoAlpha: 0 });
      const kids = main.querySelectorAll<HTMLElement>("[data-banner-reveal]");

      gsap
        .timeline()
        .to(main, { autoAlpha: 1, duration: 0.35, ease: "power2.out" })
        .from(
          kids,
          {
            autoAlpha: 0,
            y: 20,
            stagger: 0.08,
            duration: 0.65,
            ease: "power3.out",
          },
          "-=0.1",
        );
    },
    { scope },
  );

  return (
    <section
      ref={scope}
      className="relative flex min-h-[min(92dvh,920px)] flex-col overflow-hidden bg-[#ff5c00] pt-24 pb-16 font-sans text-white md:pt-28 md:pb-20"
      aria-labelledby="careers-hero-heading"
    >
      <div className="pointer-events-none absolute inset-0" aria-hidden>
        <div className="absolute inset-0 bg-[#ff5c00]" />
        {/* Soft S-curve / flame-like depth — darker orange, low contrast */}
        <div className="absolute -right-[8%] top-1/2 h-[135%] w-[min(78vw,760px)] -translate-y-1/2 rounded-[48%] bg-[#d94800]/45 blur-[80px]" />
        <div className="absolute right-[6%] top-[12%] h-[58%] w-[min(42vw,420px)] rounded-[50%] bg-[#c73e00]/30 blur-[56px]" />
        <div className="absolute right-[28%] top-[38%] h-[42%] w-[min(35vw,340px)] -rotate-6 rounded-[45%] bg-[#ff7033]/25 blur-[48px]" />
      </div>

      <div
        ref={mainRef}
        className="invisible relative z-10 flex flex-1 flex-col justify-start opacity-0"
      >
        <div className="site-content flex flex-1 flex-col py-6 md:py-10 lg:min-h-0">
          <div className="grid flex-1 grid-cols-1 lg:min-h-0">
            <div className="max-w-2xl lg:self-center">
              <h1
                data-banner-reveal
                className="text-sm font-medium tracking-tight text-white/85 md:text-base"
              >
                Careers
              </h1>
              <h2
                id="careers-hero-heading"
                data-banner-reveal
                className="mt-4 text-[clamp(2.85rem,9.5vw,7.25rem)] font-semibold leading-[0.92] tracking-tight text-white sm:mt-5"
              >
                We&apos;re
                <br />
                not hiring currently
              </h2>
              <p data-banner-reveal className="mt-8 text-base leading-relaxed text-white/90 md:text-lg">
                We&apos;re not hiring right now-tragic, we know. But if you think you&apos;d be an excellent
                addition to the crew, feel free to send through your CV and we&apos;ll keep it on hand for when
                something suitably awesome comes up.{" "}
                <CareersApplicationScrollLink className="border-b border-white/50 font-medium text-white transition-colors hover:border-white">
                  Complete the form below.
                </CareersApplicationScrollLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
